export function initContactForm() {
  const formElements = document.querySelectorAll(
    '.contact-form input[type="text"], .contact-form input[type="email"], .contact-form textarea'
  );

  formElements.forEach(element => {
    const label = document.querySelector(`label[for="${element.id}"]`);
    if (label) {
      let placeholderText = label.textContent.trim();
      element.setAttribute("placeholder", placeholderText);
    }
  });
}